module.exports = __webpack_public_path__ + "static/media/dummyChannelLogo.c9a19080.jpg";